// src/redux/auth/authRecoverySlice.js
import { createSlice } from '@reduxjs/toolkit';
import {
  forgotPasswordThunk,
  resetPasswordThunk,
  sendVerificationThunk,
  verifyEmailThunk
} from './authRecoveryActions';

const initialState = {
  loading: false,
  successMessage: null,
  errorMessage: null,
};

const authRecoverySlice = createSlice({
  name: 'authRecovery',
  initialState,
  reducers: {
    clearRecoveryMessages: (state) => {
      state.successMessage = null;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(forgotPasswordThunk.pending, (state) => {
        state.loading = true;
        state.errorMessage = null;
      })
      .addCase(forgotPasswordThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(forgotPasswordThunk.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      })
      .addCase(resetPasswordThunk.pending, (state) => {
        state.loading = true;
        state.errorMessage = null;
      })
      .addCase(resetPasswordThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(resetPasswordThunk.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      })
      .addCase(verifyEmailThunk.pending, (state) => {
        state.loading = true;
        state.errorMessage = null;
      })
      .addCase(verifyEmailThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(verifyEmailThunk.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      })
      .addCase(sendVerificationThunk.pending, (state) => {
        state.loading = true;
        state.errorMessage = null;
      })
      .addCase(sendVerificationThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(sendVerificationThunk.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      });
  }
});

export const { clearRecoveryMessages } = authRecoverySlice.actions;
export default authRecoverySlice.reducer;
